import {TOUR_CONSTS} from "../constants";


export const UpdateOpenStepsList = (data) => {
    return dispatch => {
        dispatch({
            type: TOUR_CONSTS.SWITCH_OPEN_STEPS_LIST,
            payload: data
        })
    }
};

export const UpdateOpenProfilePopup = (data) => {
    return dispatch => {
        dispatch({
            type: TOUR_CONSTS.SWITCH_OPEN_PROFILE_POPUP,
            payload: data
        })
    }
};


export const UpdateActiveStep = (data) => {
    return dispatch => {
        dispatch({
            type: TOUR_CONSTS.UPDATE_ACTIVE_STEP,
            payload: data
        })
    }
};
